module.exports = __webpack_public_path__ + "media/images/screenshots/live-9f7f208cad77221815223fff41a9717d.png";